import {
  ICreateOutreachResult,
  IOutreachDetail,
  IOutreachListResponse,
} from '../types/outreach.types';
import { formDataInstance, instance } from './instance';

export const outreachApi = {
  createOutreach: async (formData: FormData): Promise<ICreateOutreachResult> => {
    const response = await formDataInstance.post('/outreach/upload', formData);
    return response.data;
  },

  sendOutreach: async (
    id: number
  ): Promise<{ message: string; jobsCreated: number }> => {
    const response = await instance.post(`/outreach/${id}/send`);
    return response.data;
  },

  listOutreaches: async (
    page = 1,
    perPage = 20
  ): Promise<IOutreachListResponse> => {
    const response = await instance.get(`/outreach?page=${page}&perPage=${perPage}`);
    return response.data;
  },

  getOutreach: async (
    id: number,
    recipientPage = 1,
    recipientPerPage = 50
  ): Promise<IOutreachDetail> => {
    const response = await instance.get(
      `/outreach/${id}?recipientPage=${recipientPage}&recipientPerPage=${recipientPerPage}`
    );
    return response.data;
  },

  cancelOutreach: async (id: number): Promise<{ message: string }> => {
    const response = await instance.post(`/outreach/${id}/cancel`);
    return response.data;
  },

  retryOutreach: async (
    id: number
  ): Promise<{ message: string; jobsCreated: number }> => {
    const response = await instance.post(`/outreach/${id}/retry`);
    return response.data;
  },
};
